import { AppAction } from 'actions/types/ActionTypes'
import equal from 'fast-deep-equal'
import { BUSINESS_TRAVELLER_ACTIONS } from 'reducers/businessTravellerActionReducer'

function setSelectedBusinessTravellersAndGuests(employeeIds: Array<string> | undefined, guestCount?: number): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (!equal(employeeIds, state.businessTraveller.selectedTravellerEmployeeIds) || guestCount !== state.businessTraveller.selectedTravellerGuestCount) {
      dispatch({
        type: BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_TRAVELLER,
        employeeIds,
        guestCount,
      })
    }
  }
}

export default setSelectedBusinessTravellersAndGuests
